var prod1 ='';
var prod1developer ='';


var prod2 ='';
var prod2developer ='';







function addBestBothtoCart(){

var prodID='';
var prodDeveloperID='';



  
  
  $.getJSON('/products.json?limit=250', function(data) {
    $.each(data.products, function(key, val) { 

  $.each(val.variants, function(varKey, varVal) { 

  if(varVal.sku == prod1)
    prodID = varVal.id;

      if(varVal.sku == prod1developer)
    prodDeveloperID = varVal.id;
    
    
    });
    });


  
 $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType:"json",
            data : {
               id: prodID,
               quantity: 1
            },
            success: function (result) {
              var pathname = window.location.pathname;
              if(pathname == '/cart') {
                location.reload(true);
              }
            },
            error: function (result) {
              alert("Sorry,  this Hair Color is unavailable and cannot be added to the cart.");
            }
          });



   $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType:"json",
            data : {
               id: prodDeveloperID,
               quantity: 1
            },
            success: function (result) {
              var pathname = window.location.pathname;
              if(pathname == '/cart') {
                location.reload(true);
              }
            },
            error: function (result) {
              alert("Sorry,  this Developer is unavailable and cannot be added to the cart.");
            }
          });



    
});

  
}


function addMayAlsoBothtoCart(){
  
var prodID='';
var prodDeveloperID='';


  
  
  $.getJSON('/products.json?limit=250', function(data) {
    $.each(data.products, function(key, val) { 

  $.each(val.variants, function(varKey, varVal) { 

  if(varVal.sku == prod2)
    prodID = varVal.id;

      if(varVal.sku == prod2developer)
    prodDeveloperID = varVal.id;
    
    
    });
    });


  
 $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType:"json",
            data : {
               id: prodID,
               quantity: 1
            },
            success: function (result) {
              var pathname = window.location.pathname;
              if(pathname == '/cart') {
                location.reload(true);
              }
            },
            error: function (result) {
              alert("Sorry,  this Hair Color is unavailable and cannot be added to the cart.");
            }
          });



   $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType:"json",
            data : {
               id: prodDeveloperID,
               quantity: 1
            },
            success: function (result) {
              var pathname = window.location.pathname;
              if(pathname == '/cart') {
                location.reload(true);
              }
            },
            error: function (result) {
              alert("Sorry,  this Developer is unavailable and cannot be added to the cart.");
            }
          });



    
});

  
}


function IsEmail(email) {
  var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  if(!regex.test(email)) {
    return false;
  }else{
    return true;
  }
}

var personEmail='';


function trackUser(){
  klaviyo.push(['track', 'QuizTaken']);
}


function addEmail(){

  personEmail = '';

if(!IsEmail($('#results-email').val())){
$( "#badEmail" ).html( 'Invalid email address.' );
  
  return;
}


if(!$('#agree').is(':checked')){
      $( "#badEmail" ).html( 'You must agree to the terms below.' );
  return;
}

  
$( "#badEmail" ).html('');
personEmail=$('#results-email').val();



  $.ajax({
          type: "POST",
          url: "/contact",
          data: {
            "contact[email]":personEmail,
            "form_type":"customer",
            "contact[tags]":"newsletter",
            "utf8":"✓",
            "h-captcha-response":"",
          },
        });
  


  

var desiredColor = ""
   if($(".quiz-form input[name='desired-color']:checked").val()== 'Black')
    desiredColor = 'Black';
  else if($(".quiz-form input[name='desired-color']:checked").val()== 'BROWN')
    desiredColor = $(".quiz-form input[name='desired-shade-brown']:checked").val();
  else if($(".quiz-form input[name='desired-color']:checked").val()== 'RED')
    desiredColor = $(".quiz-form input[name='desired-shade-red']:checked").val();
  else if($(".quiz-form input[name='desired-color']:checked").val()== 'BLONDE')
    desiredColor = $(".quiz-form input[name='desired-shade-blonde']:checked").val();
  else if($(".quiz-form input[name='desired-color']:checked").val()== 'Highlights')
    desiredColor = 'Highlights';
  else if($(".quiz-form input[name='desired-color']:checked").val()== 'All Over Lightener')
    desiredColor = 'All Over Lightener';





  if($(".quiz-form input[name='color-hair']:checked").val() == 'Yes'){
  // they color their hair
    
  // Identifying a person and tracking special Klaviyo properties.

     klaviyo.identify({
    'email' : personEmail
  });

  var pushItems = [];
  
pushItems = {
	'Color-Q1' : $(".quiz-form input[name='quiz-hair-color']:checked").val(),
    'Color-Q2' : $(".quiz-form input[name='quiz-gray-shade']:checked").val(),
    'Color-Q3' : $(".quiz-form input[name='color-hair']:checked").val(),
    'Color-Q4' : $(".quiz-form input[name='kind-hair-color']:checked").val(),
    'Color-Q5' : $(".quiz-form input[name='quiz-midshaft-end-color']:checked").val(),
    'Color-Q6' : desiredColor,
    'Color-Q7' : $(".quiz-form input[name='hair-texture']:checked").val(),
    'Color-Q8' : $(".quiz-form input[name='hair-condition']:checked").val(),
    'Color-Q9' : $(".quiz-form input[name='hair-density']:checked").val(),
  	'Color-Prod1' : prod1,
    'Color-Dev1' : prod1developer,
    'Color-Prod2' : '',
    'Color-Dev2' : ''
  };



    
//setTimeout(function(){  }, 1000);

if(prod2!=''){

   pushItems["Color-Prod2"] = prod2;
     pushItems["Color-Dev2"] = prod2developer;
  /*
  klaviyo.push(['identify', {
	'Color-Prod2' : prod2,
    'Color-Dev2' : prod2developer
  }]);
  */
}
   klaviyo.push(['identify', pushItems ,trackUser]); 

  }else{
 // they don't color their hair

 klaviyo.identify({
    'email' : personEmail
  });
   
 var pushItems = [];
  
pushItems = {
	'Color-Q1' : $(".quiz-form input[name='quiz-hair-color']:checked").val(),
    'Color-Q2' : $(".quiz-form input[name='quiz-gray-shade']:checked").val(),
    'Color-Q3' : $(".quiz-form input[name='color-hair']:checked").val(),
    'Color-Q4' : $(".quiz-form input[name='kind-hair-color']:checked").val(),
    'Color-Q5' : '',
    'Color-Q6' : desiredColor,
    'Color-Q7' : $(".quiz-form input[name='hair-texture']:checked").val(),
    'Color-Q8' : $(".quiz-form input[name='hair-condition']:checked").val(),
    'Color-Q9' : $(".quiz-form input[name='hair-density']:checked").val(),
    'Color-Prod1' : prod1,
    'Color-Dev1' : prod1developer,
    'Color-Prod2' : '',
    'Color-Dev2' : ''
  };
    
//setTimeout(function(){ klaviyo.push(['track', 'QuizTaken']); }, 1000);
    
    if(prod2!=''){

       pushItems["Color-Prod2"] = prod2;
     pushItems["Color-Dev2"] = prod2developer;

      /*
  klaviyo.push(['identify', {
	'Color-Prod2' : prod2,
    'Color-Dev2' : prod2developer
  }]);
      */
}

    klaviyo.push(['identify', pushItems ,trackUser]);
  }


$( "#results-email" ).parent().parent().html( '<p>Thank you, an email with your results has been sent.</p>' );

  
}



function QuizAnswers(){

  



  

  console.log($(".quiz-form").serialize());

var desiredColor = '';

  var ABDeveloper = [2769129,2824139,2810940,2824141,2810963,2810934,2810961,2824142,2620249,2620290,2620286,2620223,2769122,2620518,2810962,2769130,2824143,2824150,2810965,2769143,2772005,2772006,2772009,2810936,2810938,2769123,2620546,2769131,2824144,2824151,2810966,2769144,2769146,2619737,2807667,2772007,2772010,2620271,2810939,2769138,2769124,2620543,2769132,2824145,2620253,2620220,2620210,2769147,2772000,2772008,2769139,2769126,2620555,2769133,2824146,2824153,2772001,2769140,2769127,2620548,2769135,2824147,2824154,2772002,2769141,2769128,2620529,2769136,2824148,2772004,2769142];
  var AACDeveloper = [2620625,2620618,2620617,2620614,2620624,2620626,2620620,2620613,2620627,2620615,2620619,2620610,2620612,2620621];
  var hlDeveloper = [2620204,2620203,2620202];
  var ultraDeveloper = [2548874,2826132];
  
  

  if($(".quiz-form input[name='desired-color']:checked").val()== 'Black')
    desiredColor = 'Black';
  else if($(".quiz-form input[name='desired-color']:checked").val()== 'BROWN')
    desiredColor = $(".quiz-form input[name='desired-shade-brown']:checked").val();
  else if($(".quiz-form input[name='desired-color']:checked").val()== 'RED')
    desiredColor = $(".quiz-form input[name='desired-shade-red']:checked").val();
  else if($(".quiz-form input[name='desired-color']:checked").val()== 'BLONDE')
    desiredColor = $(".quiz-form input[name='desired-shade-blonde']:checked").val();
  else if($(".quiz-form input[name='desired-color']:checked").val()== 'Highlights')
    desiredColor = 'Highlights';
  else if($(".quiz-form input[name='desired-color']:checked").val()== 'All Over Lightener')
    desiredColor = 'All Over Lightener';
  else
    console.log('NOT SURE');





  

console.log($(".quiz-form input[name='quiz-hair-color']:checked").val());  
console.log($(".quiz-form input[name='quiz-gray-shade']:checked").val());  
console.log($(".quiz-form input[name='quiz-midshaft-end-color']:checked").val());                               
console.log(desiredColor);


console.log($(".quiz-form input[name='desired-color']:checked").val()); 


  
		
			// color path
			if($(".quiz-form input[name='color-hair']:checked").val() == 'Yes'){
		
	// save DATA for klaviyo

              

	var hairtype = $(".quiz-form input[name='hair-texture']:checked").val();
	if(hairtype == 'Curly' || hairtype == 'Coily' )
		hairtype = 'Curly/Coily';
	else
		hairtype = 'Other';	
	

            
 
		var PRODUCTS = [];
        for (dataX in hairData.default){
          if(hairData.default[dataX]["Q1"] ==  $(".quiz-form input[name='quiz-hair-color']:checked").val()
          && hairData.default[dataX]["Q4"] ==  $(".quiz-form input[name='quiz-gray-shade']:checked").val()
          && hairData.default[dataX]["Q2"] ==  $(".quiz-form input[name='quiz-midshaft-end-color']:checked").val()
          && hairData.default[dataX]["Q3"] ==  desiredColor
          && hairData.default[dataX]["Q5"] ==  hairtype
          )
          		PRODUCTS.push(hairData.default[dataX]);
         }   
         
         //console.log(PRODUCTS);
         
         var P1 = [];
         var P2 = [];
         var flag = [];
         
         var CUSTOMERCALL = 0;
         
         for (dataResults in PRODUCTS){
	         
	       
	         
	         
	         P1.push(PRODUCTS[dataResults]["P1"]);
	         P2.push(PRODUCTS[dataResults]["P2"]);
	         flag.push(PRODUCTS[dataResults]["Flag"]);
	         
	         if(PRODUCTS[dataResults]["P1"] == "Call" || PRODUCTS[dataResults]["P2"] == "Call" || PRODUCTS[dataResults]["Flag"] == "Call")
	         	CUSTOMERCALL = 1;
         }
	         
	        
	         //console.log(P1);
              //console.log(P2);
	         
         
         
         
         
         if(CUSTOMERCALL){

  $('html,body').animate({
            scrollTop:0
        },500,function(){
           $('.quiz-steps').fadeOut();
           $('.quiz-no-results').fadeIn();
    
    setTimeout(function() {
                     equalHeights();
                  },500);
  
        });
           
          


           
           

           
         }else{

           if(!P1[0] && P2[0]){
               P1[0]=P2[0];
               P2[0]='';
              }
           
           //console.log("Product 1:"+P1[0]+"\n"+"Product 2:"+P2[0]);


    

             $('html,body').animate({
            scrollTop:0
        },500,function(){
           $('.quiz-steps').fadeOut();
           $('.quiz-results').fadeIn();
  
        });

           
           
           
           var developerIDH = '';
           
           if($.inArray(parseInt(P1[0]), ABDeveloper) !== -1)
               developerIDH = 2619728;
           else if($.inArray(parseInt(P1[0]), AACDeveloper) !== -1)
               developerIDH = 2620560;
             else if($.inArray(parseInt(P1[0]), hlDeveloper) !== -1)
               developerIDH = 2619759;
             else if($.inArray(parseInt(P1[0]), ultraDeveloper) !== -1)
               developerIDH = 2729143;
            else
              developerIDH = 2619728;


           prod1=P1[0];
           prod1developer=developerIDH;

         console.log(prod1);

          $('.cart-dropdown-radio-wrapper .custom-radiobtn-wrapper').slick('unslick');
           
           $( ".your-best-match-result-section .collection-product-grid .collection-product-grid-item" ).each(function( index ) {
 
             
             
            if( $( this ).find("[variant-sku='"+P1[0]+"']").length  ){
              //this one
              //try to select it
              $( this ).find("[variant-sku='"+P1[0]+"']").click();
 

              
                //delete the other options
              $( this ).find('.custom-radiobtn-grp input').each(function( index2 ) {

                  

                
                if( $( this ).attr("variant-sku") != P1[0]){
              
                    $(this).parent().parent().remove();
                  }
               });

              
              
            }else{

             
              if( $( this ).data("product-sku") == developerIDH  || $( this ).data("product-sku") == P1[0] ){
              //do nothing,  this is the developer that goes with the product variant
                //or this is the product with no variant
              }else{
                
              //this is not the product that you seek
                  $( this ).hide();
              }  
            }


      
             

           });


           


           if(!P2[0])
                 $('.you-may-like-result-section').hide();
           else{

        


             developerIDH = '';
           
           if($.inArray(parseInt(P2[0]), ABDeveloper) !== -1)
               developerIDH = 2619728;
           else if($.inArray(parseInt(P2[0]), AACDeveloper) !== -1)
               developerIDH = 2620560;
             else if($.inArray(parseInt(P2[0]), hlDeveloper) !== -1)
               developerIDH = 2619759;
             else if($.inArray(parseInt(P2[0]), ultraDeveloper) !== -1)
               developerIDH = 2729143;
            else
              developerIDH = 2619728;


             
           prod2=P2[0];
           prod2developer=developerIDH;

               $( ".you-may-like-result-section .collection-product-grid .collection-product-grid-item" ).each(function( index ) {
 
          

                 
            if( $( this ).find("[variant-sku='"+P2[0]+"']").length  ){
              //this one
              //try to select it
              $( this ).find("[variant-sku='"+P2[0]+"']").click();

                   



            
                        //delete the other options
              $( this ).find('.custom-radiobtn-grp  input').each(function( index2 ) {

                if( $( this ).attr("variant-sku") != P2[0]){
                  
                  $(this).parent().parent().remove();
                  
                   // $(this).parent().parent().parent().parent().parent().slick('slickRemove', index2);
                  }
               });

              
              
            }else{
              if( $( this ).data("product-sku") == developerIDH  || $( this ).data("product-sku") == P2[0] ){
              //do nothing,  this is the developer that goes with the product variant
                //or this is the product with no variant
              }else{
                
              //this is not the product that you seek
                  $( this ).hide();
              }  
            }

           });

             
           }


           //jQuery('.quiz-results .custom-radiobtn-wrapper').slick('refresh');
           jQuery('.cart-dropdown-radio-wrapper .custom-radiobtn-wrapper').slick({
      slidesToShow: 7,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      centerMode: false,
      centerPadding: '0',
      responsive: [
          {
            breakpoint: 1050,
            settings: {
              slidesToShow: 5,
            }
          },
          {
            breakpoint: 1023,
            settings: {
              slidesToShow: 4,
            }
          },
        ]
    });

          
         }
         
              setTimeout(function() {
                     equalHeights();
                  },500);
              
  	
  }else{
	  	    	// NO color path  
	  	    	
	  	    		// save DATA for klaviyo

              
		  
	var hairtype = $(".quiz-form input[name='hair-texture']:checked").val();
	if(hairtype == 'Curly' || hairtype == 'Coily' )
		hairtype = 'Curly/Coily';
	else
		hairtype = 'Other';	
	
	

		var PRODUCTS = [];
        for (dataX in hairData.default){
           if(hairData.default[dataX]["Q1"] ==  $(".quiz-form input[name='quiz-hair-color']:checked").val()
          && hairData.default[dataX]["Q4"] ==  $(".quiz-form input[name='quiz-gray-shade']:checked").val()
          && hairData.default[dataX]["Q3"] ==  desiredColor
          && hairData.default[dataX]["Q5"] ==  hairtype
          )
          		PRODUCTS.push(hairData.default[dataX]);
         }   
         
        // console.log(PRODUCTS);
         
          var P1 = [];
         var P2 = [];
         var flag = [];
         
         var CUSTOMERCALL = 0;
         
         for (dataResults in PRODUCTS){
	         
	         P1.push(PRODUCTS[dataResults]["P1"]);
	         P2.push(PRODUCTS[dataResults]["P2"]);
	         flag.push(PRODUCTS[dataResults]["Flag"]);
	         
	         if(PRODUCTS[dataResults]["P1"] == "Call" || PRODUCTS[dataResults]["P2"] == "Call" || PRODUCTS[dataResults]["Flag"] == "Call")
	         	CUSTOMERCALL = 1;
         }
         
         
         
          if(CUSTOMERCALL){


       $('html,body').animate({
            scrollTop:0
        },500,function(){
           $('.quiz-steps').fadeOut();
           $('.quiz-no-results').fadeIn();

            setTimeout(function() {
                     equalHeights();
                  },500);

         
        });
            
            
           

           
         }else{

           if(!P1[0] && P2[0]){
               P1[0]=P2[0];
               P2[0]='';
            }
           
         //  console.log("Product 1:"+P1[0]+"\n"+"Product 2:"+P2[0]);

           
         	       $('html,body').animate({
            scrollTop:0
        },500,function(){
           $('.quiz-steps').fadeOut();
           $('.quiz-results').fadeIn();
  
        });



           var developerIDH = '';
           
           if($.inArray(parseInt(P1[0]), ABDeveloper) !== -1)
               developerIDH = 2619728;
           else if($.inArray(parseInt(P1[0]), AACDeveloper) !== -1)
               developerIDH = 2620560;
             else if($.inArray(parseInt(P1[0]), hlDeveloper) !== -1)
               developerIDH = 2619759;
             else if($.inArray(parseInt(P1[0]), ultraDeveloper) !== -1)
               developerIDH = 2729143;
            else
              developerIDH = 2619728;

            

            prod1=P1[0];
           prod1developer=developerIDH;

    $('.cart-dropdown-radio-wrapper .custom-radiobtn-wrapper').slick('unslick');
            
           $( ".your-best-match-result-section .collection-product-grid .collection-product-grid-item" ).each(function( index ) {
 
           
            if( $( this ).find("[variant-sku='"+P1[0]+"']").length  ){
              //this one
              //try to select it
              $( this ).find("[variant-sku='"+P1[0]+"']").click();

                       //delete the other options
              $( this ).find('.custom-radiobtn-grp input').each(function( index2 ) {

                if( $( this ).attr("variant-sku") != P1[0]){
                 
                    $(this).parent().parent().remove();
                  }
               });

              
              
            }else{
                  
              if( $( this ).data("product-sku") == developerIDH  || $( this ).data("product-sku") == P1[0] ){
              //do nothing,  this is the developer that goes with the product variant
                //or this is the product with no variant
              }else{
                
              //this is not the product that you seek
                  $( this ).hide();
              } 
              
            }

           });


           if(!P2[0])
                 $('.you-may-like-result-section').hide();
           else{



              developerIDH = '';
           
           if($.inArray(parseInt(P2[0]), ABDeveloper) !== -1)
               developerIDH = 2619728;
           else if($.inArray(parseInt(P2[0]), AACDeveloper) !== -1)
               developerIDH = 2620560;
             else if($.inArray(parseInt(P2[0]), hlDeveloper) !== -1)
               developerIDH = 2619759;
             else if($.inArray(parseInt(P2[0]), ultraDeveloper) !== -1)
               developerIDH = 2729143;
            else
              developerIDH = 2619728;


             prod2=P2[0];
           prod2developer=developerIDH;

               $( ".you-may-like-result-section .collection-product-grid .collection-product-grid-item" ).each(function( index ) {
 
             
            if( $( this ).find("[variant-sku='"+P2[0]+"']").length  ){
              //this one
              //try to select it
              $( this ).find("[variant-sku='"+P2[0]+"']").click();


                  //delete the other options
              $( this ).find('.custom-radiobtn-grp input').each(function( index2 ) {

                if( $( this ).attr("variant-sku") != P2[0]){
                 
                    $(this).parent().parent().remove();
                  }
               });

              
              
            }else{
            if( $( this ).data("product-sku") == developerIDH || $( this ).data("product-sku") == P2[0] ){
              //do nothing,  this is the developer that goes with the product variant
              //or this is the product with no variant
              }else{
                
              //this is not the product that you seek
                  $( this ).hide();
              }  
            }

           });

             
           }


           jQuery('.cart-dropdown-radio-wrapper .custom-radiobtn-wrapper').slick({
      slidesToShow: 7,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      centerMode: false,
      centerPadding: '0',
      responsive: [
          
          {
            breakpoint: 1050,
            settings: {
              slidesToShow: 5,
            }
          },
          {
            breakpoint: 1023,
            settings: {
              slidesToShow: 4,
            }
          },
        ]
    });

           
         }

               setTimeout(function() {
                     equalHeights();
                  },500);
         
         
        
	  
	  
  }
  	

  
  
}


jQuery(document).ready(function(){  




  
    // get started
      jQuery('.quiz-get-started .get-started-btn').click(function(e){
        e.preventDefault();

        jQuery('.quiz-step-1-outer').slideDown();
                  
              setTimeout(function() {
                      jQuery('.quiz-step-1-outer .quiz-row-wrapper .quiz-row-slider').slick('refresh');
                  },500);

        

        
        
        var start_scroll_top = jQuery(this).closest('.quiz-page-wrapper').find('.quiz-step-section').offset().top
        jQuery('html,body').animate({
            scrollTop:start_scroll_top
        },1100);
      });
      var quizFlag = false;
    // quiz steps
       jQuery('.quiz-box-radio .quiz-box-radio-inner input').change(function(){
          if(jQuery(this).closest('.quiz-step-outer').next('.quiz-step-outer[data-step]').length) {
              // inner main steps input change
              if(jQuery(this).closest('.quiz-step-outer').hasClass('has-inner-steps') && jQuery(this).closest('.quiz-step').hasClass('inner-main-step') && jQuery(this).attr('data-link-step')!='no-sub-step'){ 
                var _this = jQuery(this);
                var _this_sub_step = jQuery(this).attr('data-link-step');
                jQuery(this).closest('.quiz-step-outer').find('.quiz-step[data-targeted-step="'+_this_sub_step+'"]').slideDown();
                jQuery(this).closest('.quiz-step-outer').find('.quiz-step[data-targeted-step="'+_this_sub_step+'"]').siblings('.quiz-step[data-targeted-step]').slideUp();
                  setTimeout(function() {
                      if(_this.closest('.quiz-step-outer').find('.quiz-step[data-targeted-step="'+_this_sub_step+'"]').find('.quiz-row-slider').length) {
                          jQuery('.quiz-row-wrapper .quiz-row-slider').slick('refresh');
                      }
                      var sub_step_scroll = _this.closest('.quiz-step-outer').find('.quiz-step[data-targeted-step="'+_this_sub_step+'"]').offset().top;
                      jQuery('html,body').animate({
                          scrollTop:sub_step_scroll
                      },1100);
                      _this.closest('.quiz-step-outer').find('.quiz-step[data-targeted-step="'+_this_sub_step+'"] .question').focus();
                  },500);
              }
              else if(jQuery(this).attr('data-link-step')=='not-color-hair') {
                var _this = jQuery(this);
                var _not_color_hair = _this.attr('data-link-step');
                _this.closest('.quiz-step-outer').nextAll('.quiz-step-outer[data-targeted-step="'+_not_color_hair+'"]').slideDown();
                jQuery(this).closest('.quiz-step-outer').nextAll('.skip-step').slideUp();                
                setTimeout(function(){                  
                  var not_color_hair_scroll = _this.closest('.quiz-step-outer').nextAll('.quiz-step-outer[data-targeted-step="'+_not_color_hair+'"]').offset().top;
                  jQuery('html,body').animate({
                    scrollTop:not_color_hair_scroll
                  },1100);
                  _this.closest('.quiz-step-outer').nextAll('.quiz-step-outer[data-targeted-step="'+_not_color_hair+'"] .question').focus();
                  _this.closest('.quiz-step-outer').nextAll('.quiz-step-outer[data-targeted-step="'+_not_color_hair+'"]').addClass('current-step').siblings().removeClass('current-step');
                },500);
                var nextAllIndex = _this.closest('.quiz-step-outer').nextAll('.quiz-step-outer:not(.skip-step)');
                var currentIndex;
                for(var i = 0; i < nextAllIndex.length; i++){
                  currentIndex = nextAllIndex[i];
                  var currentStepValue = jQuery(currentIndex).attr('step-value-alt');
                  jQuery(currentIndex).find('.counter').text(currentStepValue);
                }    
                quizFlag = true;            
              }
              else {
                  // normal steps input change
                  var _this = jQuery(this);
                  _this.closest('.quiz-step-outer').next('.quiz-step-outer[data-step]').slideDown("fast", function() {
    // Animation complete.
  });
                  setTimeout(function(){
                    
                      if(_this.closest('.quiz-step-outer').next('.quiz-step-outer[data-step]').find('.quiz-row-slider').length) {
                        //  jQuery('.quiz-row-wrapper .quiz-row-slider').slick('refresh');
                        _this.closest('.quiz-step-outer').next('.quiz-step-outer[data-step]').find('.quiz-row-slider').slick('refresh');
                      }
                      var step_scroll =  _this.closest('.quiz-step-outer').next('.quiz-step-outer[data-step]').offset().top;
                      jQuery('html,body').animate({
                          scrollTop:step_scroll
                      },1100);
                      _this.closest('.quiz-step-outer').next('.quiz-step-outer[data-step]').find('.question').focus();
                      _this.closest('.quiz-step-outer').next('.quiz-step-outer[data-step]').addClass('current-step').siblings().removeClass('current-step');
                  },500);
                  if(jQuery(this).attr('data-link-step')=='no-sub-step') {
                    jQuery(this).closest('.quiz-step-outer').find('.quiz-step[data-targeted-step]').slideUp();
                  }
                  if(jQuery(this).attr('data-link-step')=='yes-color-hair' && quizFlag){
                    var nextAllIndex = _this.closest('.quiz-step-outer').nextAll('.quiz-step-outer');
                    var nextIndex;
                    for(var i = 0; i < nextAllIndex.length; i++){
                      nextIndex = nextAllIndex[i];
                      var currentDataStep = jQuery(nextIndex).attr('data-step');
                      var currentDataStepArray = currentDataStep.split("-");                                    
                      jQuery(nextIndex).find('.counter').text(currentDataStepArray[2]);
                    }
                    jQuery(this).closest('.quiz-step-outer').nextAll('.skip-step').slideDown(); 
                    if(jQuery(this).closest('.quiz-step-outer').nextAll('.skip-step').find('.quiz-row-wrapper .quiz-row-slider').length){
                      jQuery(this).closest('.quiz-step-outer').nextAll('.skip-step').find('.quiz-row-wrapper .quiz-row-slider').slick('refresh');
                    }                    
                    quizFlag = false;
                  }                  
              }
              jQuery(this).closest('.quiz-step-outer').nextAll('.quiz-step-outer[data-step]').find('input').prop('checked', false);
              jQuery(this).closest('.quiz-step-outer').nextAll('.quiz-step-outer[data-step]').find('.quiz-step[data-targeted-step]').slideUp();              
          }
          else {
              jQuery(this).closest('.quiz-step-outer').find('.quiz-steps-submit-btn').fadeIn(500);
          }
      });

      // inner step swatches
      jQuery('.quiz-step-outer.has-inner-steps .quiz-step[data-targeted-step] .quiz-box-radio .quiz-box-radio-inner input').change(function(){ 
          var _this = jQuery(this);
          _this.closest('.quiz-step-outer').next('.quiz-step-outer[data-step]').slideDown();
          jQuery(this).closest('.quiz-step-outer').next('.quiz-step-outer[data-step]').addClass('current-step').siblings().removeClass('current-step');
          setTimeout(function(){
              if(_this.closest('.quiz-step-outer').next('.quiz-step-outer[data-step]').find('.quiz-row-slider').length) {
                  jQuery('.quiz-row-wrapper .quiz-row-slider').slick('refresh');
              }
              var sub_step_next_scroll =  _this.closest('.quiz-step-outer').next('.quiz-step-outer[data-step]').offset().top;
              jQuery('html,body').animate({
                  scrollTop:sub_step_next_scroll
              },1100);
              _this.closest('.quiz-step-outer').next('.quiz-step-outer[data-step]').find('.question').focus();
          },500);
      });
  
    // step popup
      var current_input_id;
      jQuery('.quiz-box-radio .quiz-box-radio-inner .swatch-zoom-link').click(function(e){
         // e.stopPropagation();
          e.preventDefault();
          current_input_id = jQuery(this).closest('.quiz-box-radio').find('input').attr('id');
          var current_img = jQuery(this).closest('.quiz-box-radio').find('.quiz-img-box img').attr('src');
          jQuery('.quiz-popup .img-block img').attr('src',current_img);
          jQuery('.quiz-popup').addClass('tab-focus-none');
        
      });

      // popup select btn
      jQuery('.custom-popup.quiz-popup .select-btn').click(function(e){
           e.preventDefault();
          jQuery('body,html').removeClass('overflow-hidden');
          jQuery('.custom-popup').removeClass('popup-open');
          setTimeout(function () {
              jQuery('.custom-popup').removeClass('show');
              jQuery('.quiz-box-radio .quiz-box-radio-inner input[id="'+current_input_id+'"]').trigger('click');
          }, 500)
          
      });

      jQuery('.custom-popup.quiz-popup .cancel-link,.custom-popup.quiz-popup .popup-dialog-wrapper,.custom-popup.quiz-popup .close-popup').click(function(){
        jQuery(this).blur();
        setTimeout(function(){
         jQuery('.quiz-box-radio .quiz-box-radio-inner input[id="'+current_input_id+'"]').closest('.quiz-box-radio').find(".swatch-zoom-link").focus();
        },10)
      });
      jQuery(window).bind('keydown', function (e) {
          // SPACE key
          if (e.keyCode == 32) {
              e.preventDefault();
              jQuery(".quiz-box-radio").each(function () {
                  var _this = jQuery(this);
                  if (_this.is(':focus')) {
                      _this.find('input').click();
                  }
              });
             
          }

          // ENTER key
          if (e.keyCode == 13) {
            if(jQuery('.quiz-popup .close-popup').is(":focus")){
               jQuery(this).trigger('click');
            }
            if(jQuery('.quiz-popup .cancel-link').is(":focus")){
               jQuery(this).trigger('click');
            }
            if(jQuery('.quiz-popup .select-btn').is(":focus")){
               jQuery(this).trigger('click');
            }
          }

          // TAB key
          if (e.keyCode == '9') {
            if(jQuery('.quiz-popup.tab-focus-none').hasClass('show')){
                jQuery('.quiz-box-radio .quiz-box-radio-inner .swatch-zoom-link').blur();
                setTimeout(function(){
                  jQuery('.quiz-popup .close-popup').focus();
                },10)
                jQuery('.quiz-popup').removeClass('tab-focus-none');
            }
            if(jQuery('.custom-popup.quiz-popup .cancel-link').is(":focus")){
                console.log('cancel focus');
                jQuery(this).blur();
                setTimeout(function(){
                  jQuery('.quiz-popup .close-popup').focus();
                },10)
            }
          }

          // ESC key
          if (e.keyCode == '27') {
             if(jQuery('.quiz-popup').hasClass('show')){
                jQuery('.quiz-popup .close-popup').trigger('click');
            }
          }
      });
  });